export default function useImagePreloader() {
  return function preloadImage(url: string) {
    const img = new Image();
    img.src = url;
  };
}
